import React from 'react';

const SvgMultipleChoice = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M1.946 10.164a1.946 1.946 0 1 0 1.946 1.946 1.946 1.946 0 0 0-1.946-1.946zm0-7.783a1.946 1.946 0 1 0 1.946 1.945 1.945 1.945 0 0 0-1.946-1.945zm0 15.788a1.725 1.725 0 1 0 1.725 1.725 1.723 1.723 0 0 0-1.722-1.725zm3.892 3.022H24V18.6H5.838zm0-7.783H24v-2.595H5.838zm0-10.379v2.6H24v-2.6z" />
  </svg>
);

export default SvgMultipleChoice;
